// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
export { InternetBarConfig, InternetBar, InternetBarEditable } from './InternetBar';
export { type InternetBarProps } from './InternetBar.types';
